import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Button,
    Container,
    Row,
    Col,
    Collapse
} from 'reactstrap';
import {Login as LoginForm, Register as RegisterForm} from '../Forms';
import {doSignIn, doSignUp} from '../../actions/authAction';
import {connect} from 'react-redux';

class ModalLogin extends Component{
    constructor(props){
        super(props);
        this.state={
            sections:'signin'
        }
        this._changeSection=this._changeSection.bind(this);
        this._toggle=this._toggle.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.dataSignIn.isSubmit === false && nextProps.dataSignIn.isSubmit!==this.props.dataSignIn.isSubmit){
            if(nextProps.dataSignIn.status_code===200){
                this.props.toggle();
            }
        }
        if(nextProps.dataSignUp.isSubmit === false && nextProps.dataSignUp.isSubmit!==this.props.dataSignUp.isSubmit){
            if(nextProps.dataSignUp.status_code===200){
                this._toggle();
            }
        }
    }

    _changeSection(name){
        this.setState({sections:name});
    }

    _toggle(){
        if(!this.props.dataSignIn.isSubmit&&!this.props.dataSignUp.isSubmit){
            this.props.toggle();
        }
    }

    render(){
        return(
            <Modal isOpen={this.props.isOpen} toggle={this._toggle} className="kick-modal" id="modal-login-register">
                <ModalHeader toggle={this._toggle}>Login / Register</ModalHeader>
                <ModalBody>
                    <Collapse isOpen={this.state.sections==='signin'}>
                        <Container>
                            <LoginForm onSubmit={this.props.login} data={this.props.dataSignIn}/>
                        </Container>
                    </Collapse>
                    <Collapse isOpen={this.state.sections==='register'}>
                        <Container>
                            <RegisterForm onSubmit={this.props.register} data={this.props.dataSignUp}/>
                        </Container>
                    </Collapse>
                    <Container className="other-option-container">
                        <div className="title">atau</div>
                        {/* <Container> */}
                            {/*
                            <Row>
                                <Col xs={12} md={{size:8,offset:2}} >
                                    <Button className="btn-facebook bold" block size="lg">Facebook</Button>
                                </Col>
                            </Row>
                            */}
                            {/* <Row> */}
                                <Col xs={12} md={{size:8,offset:2}} >
                                    {
                                        this.state.sections==='signin'?
                                            <Button className="btn-green bold" block size="lg" onClick={()=>this._changeSection('register')}>REGISTER</Button>
                                        :
                                            <Button className="btn-green bold" block size="lg" onClick={()=>this._changeSection('signin')}>LOGIN</Button>
                                    }
                                </Col>
                            {/* </Row> */}
                        {/* </Container> */}
                    </Container>
                </ModalBody>
            </Modal>
        )
    }
}
const mapStateToProps = state =>({
    dataSignIn:state.dataAuth.signIn,
    dataSignUp:state.dataAuth.signUp,
})
const mapDispatchToProps = dispatch =>({
    login : ({email,password}) => dispatch(doSignIn({email,password})),
    register : ({email,password}) => dispatch(doSignUp({email,password}))
})
export default connect(mapStateToProps,mapDispatchToProps)(ModalLogin);
